<template>
    <div class="dashboard">
        <div class="mx-0 px-0">
            <div class="row align-items-center mb-4">
                <div class="col-12 col-md-5">
                    <h1 class="main-title mb-0 title-responsive">
                        Inventario de Productos Químicos <span class="text-primary">(PQ)</span>
                    </h1>
                </div>
                <div class="col-12 col-md-7">
                    <div class="row kpi-row">
                        <div class="col-12 col-md-4 mb-1 mb-md-0">
                            <StatsCard :value="dataDash1.total_inventory" title="Total RPQ" />
                        </div>
                        <div class="col-12 col-md-4 mb-1 mb-md-0">
                            <StatsCard :value="dataDash1.un_danger_total" title="Mercancías peligrosas" />
                        </div>
                        <div class="col-12 col-md-4">
                            <StatsCard :value="productNotDangerCount" title="Sin afectaciones para la salud" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="dashboard-grid">
                <div class="left-column pr-md-2 pr-0" ref="leftColumn">
                    <div class="tree-section mx-0 px-0 pr-md-2 pr-0">
                        <div class="row equal-height">
                            <div class="col-12 col-md-6 mb-4 mb-md-0">
                                <div class="h-100">
                                    <LegislationChart :data="{
                                        characterized: dataDash1.total_inventory_verified_cumply || 0,
                                        certificate_not_risk: dataDash1.certificate_not_risk || 0,
                                        nonCompliant: dataDash1.not_comply || 0,
                                        noDocument: dataDash1.not_document || 0,
                                        fdsWithReviewed: (dataDash1.total_inventory_verified_cumply - dataDash1.attachment_not_revision) || 0,
                                        fdsNotReviewed: dataDash1.attachment_not_revision || 0,
                                        notCaracterizedWithCumply: dataDash1.total_inventory_for_verification_cumply || 0,
                                        totalInventory: dataDash1.total_inventory || 0,
                                        customLabels: dataDash1.custom_labels || {}
                                    }" :show-review-section="showRegulatoryReview" />
                                </div>
                            </div>
                            <div class="col-12 d-block d-md-none">
                                <IconList :items="items" @chart-segment-clicked="handleSegmentClick"
                                    :isLoading="isLoadingChartInfo['tank'] || isLoadingChartInfo['msds'] || isLoadingChartInfo['fds_not_spain']" />
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="d-flex flex-column h-100 secondary-chart">
                                    <ChartCard title="Estatus Productos Caracterizados" :showInfoButton="true"
                                        chartKey="status_inventory" :options="statusInventoryChartOptions"
                                        :isLoading="isLoadingChartInfo['status_inventory'] || isLoadingChartInfo['caracterized'] || isLoadingChartInfo['not_caracterized_with_cumply'] || isLoadingChartInfo['not_caracterized_not_cumply'] || isLoadingChartInfo['not_document']"
                                        @chart-segment-clicked="handleSegmentClick"
                                        @chart-info-click="handleChartInfo" />
                                    <div class="d-none d-md-block">
                                        <IconList :items="items" @chart-segment-clicked="handleSegmentClick"
                                            :isLoading="isLoadingChartInfo['tank'] || isLoadingChartInfo['msds'] || isLoadingChartInfo['fds_not_spain']" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right-column px-0 mx-0" ref="rightColumn">
                    <div class="scrollable-content px-0 mx-0" ref="scrollableContent" :style="scrollableStyles">
                        <div class="charts-container px-0 mx-0">
                            <div class="row px-0 mx-0">
                                <div class="col-12 col-xl-12 col-md-12 mb-4 mb-4 px-0 pl-md-1 mt-3">
                                    <ChartCard title="Peligrosidad del Inventario" :showInfoButton="true"
                                        chartKey="risk-inventory" :options="riskInventoryChartOptions"
                                        :isLoading="isLoadingChartInfo['sga_physical'] || isLoadingChartInfo['sga_health'] || isLoadingChartInfo['sga_environment'] || isLoadingChartInfo['risk-inventory']"
                                        @chart-segment-clicked="handleSegmentClick"
                                        @chart-info-click="handleChartInfo" />
                                </div>
                                <div class="col-12 col-xl-12 col-md-12 mb-4 px-0 px-md-2">
                                    <ChartCard title="Disponibilidad en inventario" :showInfoButton="true"
                                        chartKey="inventory_availability" :options="useandDesuseChartOptions"
                                        :isLoading="isLoadingChartInfo['used'] || isLoadingChartInfo['not_use'] || isLoadingChartInfo['inventory_availability']"
                                        @chart-segment-clicked="handleSegmentClick"
                                        @chart-info-click="handleChartInfo" />
                                </div>
                                <div class="col-12 col-xl-12 col-md-12 mb-4 mb-md-0 px-0 px-md-2"
                                    v-if="validarPermisoComponente(['ver-grafica-productos-sujetos-regulacion']) && showRegulationChart">
                                    <ChartCard title="Sujetos a regulación" @chart-info-click="handleChartInfo"
                                        :showInfoButton="false" chartKey="subjects_regulation"
                                        :options="optionsBarsSuggestionRegulation"
                                        :isLoading="isLoadingChartInfo['subjects_regulation'] || isLoadingChartInfo['ppam'] || isLoadingChartInfo['sga_death'] || isLoadingChartInfo['carcinogenic'] || isLoadingChartInfo['un_danger']"
                                        @chart-segment-clicked="handleSegmentClick" />
                                </div>
                                <div class="col-12 col-xl-12 col-md-12 mb-4 mb-md-0 px-0 px-md-2"
                                    v-if="validarPermisoComponente(['ver-grafica-analisis-riesgo'])">
                                    <ChartCard title="Analisis de riesgos" @chart-info-click="handleChartInfo"
                                        :showInfoButton="false" chartKey="priority" :options="riskAnalysisChartOptions"
                                        :isLoading="isLoadingChartInfo['priority']"
                                        messageNoData="No se han realizado análisis de riesgos a través de Soluquim." />
                                </div>
                                <div class="col-12 col-xl-12 col-md-12 mb-4 mb-md-0 px-0 px-md-2"
                                    v-if="dataDash1 && dataDash1.show_benefits_chart !== false">
                                    <ChartCard title="FDS actualizados como beneficio"
                                        @chart-info-click="handleChartInfo" :showInfoButton="false"
                                        chartKey="carcinogenicity" :options="benefitForYearsChartOptions"
                                        :isLoading="isLoadingChartInfo['carcinogenicity']" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ProductListModal :modal-id="'products-modal'" :title="modalTitle" :products="selectedProducts"
            :keyProduct="keyProducts" />
    </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ChartCard from '../components/health/ChartCard.vue';
import IndicatorCard from '../components/health/IndicatorCard.vue';
import StatsCard from '../components/health/StatsCard.vue';
import CenterBody from '../components/health/CenterBody.vue';
import ProductListModal from '../components/ProductListModal.vue';
import LegislationChart from '../components/general/LegislationChart.vue';
import IconList from '../components/general/IconList.vue';
import { validarPermisoComponente } from "../../../plugins/acl";
import {
    getCategoryChartOptions,
    getCarcinogenicityChartOptions,
    getPriorityChartOptions,
    productsChartOptions,
    healthEffectsChartOptions,
    sensitizersChartOptions,
    getReprotoxicityChartOptions,
    getOtoxicityChartOptions,
    getMutagenicityChartOptions,
    getHealthCategoriesChartOptions,
    getNeurotoxicChartOptions,
    getCorrosiveChartOptions,
    getSensitizingChartOptions,
    getStatusInventoryPQChartOptions,
    getRiskInventoryChartOptions,
    getUseandDesuseChartOptions,
    getOptionsBarsSuggestionRegulation,
    getBenefitForYearsChartOptions,
    getRiskAnalysisChartOptions
} from '../config/chartOptions';

export default {
    name: 'Health',
    components: {
        ChartCard,
        IndicatorCard,
        StatsCard,
        CenterBody,
        ProductListModal,
        LegislationChart,
        IconList,
    },
    data() {
        return {
            priorityCurrentPage: 1,
            productsChartOptions,
            healthEffectsChartOptions,
            sensitizersChartOptions,
            modalTitle: '',
            selectedProducts: [],
            chartInfoButtons: {
                acute_toxicity_mortal: true,
                carcinogenicity: true,
                components_priority_normative: false,
                reprotoxicity: true,
                otoxicity: true,
                neurotoxic: true,
                corrosive: true,
                mutagenicity: true,
                sensitizing: true,
                products_by_location: false
            },
            keyProducts: '',
            isLoadingChartInfo: {},
            validarPermisoComponente: validarPermisoComponente,
            // Observadores para altura dinámica
            resizeObserver: null,
            mutationObserver: null,
            scrollableHeight: 'auto',
            // Debounce para optimizar
            resizeTimeout: null,
        };
    },
    computed: {
        ...mapState("dashboard", ["dataDash1", "dataDash2", "dashboardFilters", "productsDashAffected"]),
        ...mapState("configurableVariables", ["allCountries"]),
        
        resolvedCountrySetting() {
            if (!this.allCountries || this.allCountries.length === 0) return null;

            const filterCountryId = this.dashboardFilters.country_id;

            if (filterCountryId) {
                const match = this.allCountries.find(c => c.country.id === filterCountryId);
                return (match && match.country) ? match.country.country_setting || null : null;
            }

            const mainCountry = this.allCountries.find(c => c.is_main === 1) || this.allCountries[0];
            return (mainCountry && mainCountry.country) ? mainCountry.country.country_setting || null : null;
        },

        showRegulationChart() {
            if (!this.resolvedCountrySetting) return true;
            return this.resolvedCountrySetting.show_regulation_chart === true;
        },

        showRegulatoryReview() {
            if (!this.resolvedCountrySetting) return true;
            return this.resolvedCountrySetting.has_regulatory_review === true;
        },

        // Estilos computados para el contenedor scrollable
        scrollableStyles() {
            return {
                maxHeight: this.scrollableHeight,
                height: this.scrollableHeight
            };
        },
        
        categoryChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getCategoryChartOptions(this.dataDash2);
        },
        carcinogenicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getCarcinogenicityChartOptions(this.dataDash2);
        },
        priorityFullData() {
            return (this.dataDash2 && this.dataDash2.components_priority_normative) || [];
        },
        priorityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getPriorityChartOptions(this.dataDash2, this.priorityCurrentPage, 10);
        },
        reprotoxicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getReprotoxicityChartOptions(this.dataDash2);
        },
        otoxicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getOtoxicityChartOptions(this.dataDash2);
        },
        mutagenicityChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getMutagenicityChartOptions(this.dataDash2);
        },
        healthCategoriesChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getHealthCategoriesChartOptions(this.dataDash2);
        },
        neurotoxicChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getNeurotoxicChartOptions(this.dataDash2);
        },
        corrosiveChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getCorrosiveChartOptions(this.dataDash2);
        },
        sensitizingChartOptions() {
            if (!this.dataDash2 || !this.dataDash2.consulted) return {};
            return getSensitizingChartOptions(this.dataDash2);
        },
        fdsWithReview() {
            if (!this.dataDash1 || !this.dataDash1.consulted) return 0;
            return this.dataDash1.attachment_with_revision;
        },
        productNotDangerCount() {
            if (!this.dataDash1 || !this.dataDash1.consulted) return 0;
            return this.dataDash1.product_not_danger_count;
        },
        items() {
            const itemTak = {
                icon: 'TanquesIcon',
                number: this.dataDash1.total_tanks || 0,
                text: 'Tanques',
                key: 'tank'
            };

            const itemInstalacion = {
                icon: 'InstalacionesIcon',
                number: this.dataDash1.classified_facilities || 0,
                text: 'Instalaciones Clasificadas',
                key: null
            };

            let itemReturn = [
                {
                    icon: 'FdsIcon',
                    number: this.dataDash1.fds_not_spain || 0,
                    text: (this.dataDash1.custom_labels && this.dataDash1.custom_labels.fds_foreign) ? this.dataDash1.custom_labels.fds_foreign : 'FDS Otros Idiomas',
                    key: "fds_not_spain"
                },
                {
                    icon: 'MsdsIcon',
                    number: this.dataDash1.msds_strict_count || 0,
                    text: 'Documentos sin SGA',
                    key: "msds"
                }
            ];

            if (this.validarPermisoComponente(['ver-conteo-tanques-tablero-general'])) {
                itemReturn.push(itemTak);
            }
            if (this.validarPermisoComponente(['ver-conteo-instalaciones-clasificadas-tablero-general'])) {
                itemReturn.push(itemInstalacion);
            }

            return itemReturn;
        },
        statusInventoryChartOptions() {
            if (!this.dataDash1 || !this.dataDash1.consulted) return {};
            return getStatusInventoryPQChartOptions(this.dataDash1);
        },
        riskInventoryChartOptions() {
            if (!this.dataDash1 || !this.dataDash1.consulted) return {};
            return getRiskInventoryChartOptions(this.dataDash1);
        },
        useandDesuseChartOptions() {
            if (!this.dataDash1 || !this.dataDash1.consulted) return {};
            return getUseandDesuseChartOptions(this.dataDash1);
        },
        optionsBarsSuggestionRegulation() {
            if (!this.dataDash1 || !this.dataDash1.consulted) return {};
            return getOptionsBarsSuggestionRegulation(this.dataDash1);
        },
        benefitForYearsChartOptions() {
            if (!this.dataDash1 || !this.dataDash1.consulted) return {};
            return getBenefitForYearsChartOptions(this.dataDash1);
        },
        riskAnalysisChartOptions() {
            if (!this.dataDash1 || !this.dataDash1.consulted) return {};
            return getRiskAnalysisChartOptions(this.dataDash1);
        },
    },
    methods: {
        ...mapActions("dashboard", ["findDataProducts", "findDataProductsByCompanyAndSegment"]),
        ...mapMutations("dashboard", ["resetProductsDashAffected"]),

        handlePriorityPageChange(newPage) {
            this.priorityCurrentPage = newPage;
        },
        
        async handleChartInfo({ key, title }) {
            this.keyProducts = key;
            this.$set(this.isLoadingChartInfo, key, true);
            this.modalTitle = title;
            this.resetProductsDashAffected();

            try {
                const filters = {
                    ...this.dashboardFilters,
                    segment: key,
                };
                await this.findDataProductsByCompanyAndSegment(filters);
                this.selectedProducts = this.productsDashAffected;
                this.$bvModal.show('products-modal');
            } catch (error) {
                console.error('Error al cargar los productos:', error);
            }
            finally {
                this.$set(this.isLoadingChartInfo, key, false);
            }
        },
        
        async handleSegmentClick(data) {
            this.keyProducts = data.key;
            this.$set(this.isLoadingChartInfo, data.key, true);
            this.modalTitle = data.title;
            this.resetProductsDashAffected();

            try {
                const filters = {
                    ...this.dashboardFilters,
                    segment: data.key,
                };
                await this.findDataProductsByCompanyAndSegment(filters);
                this.selectedProducts = this.productsDashAffected;
                this.$bvModal.show('products-modal');
            } catch (error) {
                console.error('Error al cargar los productos:', error);
            }
            finally {
                this.$set(this.isLoadingChartInfo, data.key, false);
            }
        },
        
        // Método principal para calcular la altura
        calculateScrollableHeight() {
            // Limpiar timeout anterior si existe
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }

            // Debounce para evitar cálculos excesivos
            this.resizeTimeout = setTimeout(() => {
                this.updateScrollableHeight();
            }, 50);
        },
        
        // Actualizar altura del contenedor scrollable
        updateScrollableHeight() {
            // Solo aplicar en pantallas grandes (desktop)
            if (window.innerWidth <= 991) {
                this.scrollableHeight = 'auto';
                return;
            }

            this.$nextTick(() => {
                const leftColumn = this.$refs.leftColumn;
                
                if (!leftColumn) {
                    this.scrollableHeight = 'auto';
                    return;
                }

                // Obtener altura real del contenido de la columna izquierda
                const leftHeight = leftColumn.scrollHeight;
                
                // Aplicar la altura calculada
                this.scrollableHeight = `${leftHeight}px`;
            });
        },
        
        // Configurar observadores
        setupObservers() {
            // ResizeObserver para cambios de tamaño
            if ('ResizeObserver' in window) {
                this.resizeObserver = new ResizeObserver(() => {
                    this.calculateScrollableHeight();
                });
                
                // Observar la columna izquierda
                if (this.$refs.leftColumn) {
                    this.resizeObserver.observe(this.$refs.leftColumn);
                }
                
                // Observar el documento completo para cambios de zoom
                this.resizeObserver.observe(document.documentElement);
            }
            
            // MutationObserver para cambios en el DOM
            if ('MutationObserver' in window) {
                this.mutationObserver = new MutationObserver(() => {
                    this.calculateScrollableHeight();
                });
                
                if (this.$refs.leftColumn) {
                    this.mutationObserver.observe(this.$refs.leftColumn, {
                        childList: true,
                        subtree: true,
                        attributes: true,
                        attributeFilter: ['style', 'class']
                    });
                }
            }
        },
        
        // Limpiar observadores
        cleanupObservers() {
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
                this.resizeObserver = null;
            }
            
            if (this.mutationObserver) {
                this.mutationObserver.disconnect();
                this.mutationObserver = null;
            }
            
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
                this.resizeTimeout = null;
            }
        }
    },
    
    mounted() {
        // Configurar observadores
        this.setupObservers();
        
        // Cálculo inicial
        this.$nextTick(() => {
            this.calculateScrollableHeight();
        });
        
        // Event listener para resize de ventana (backup)
        window.addEventListener('resize', this.calculateScrollableHeight);
        
        // Event listener para cambios de zoom
        window.addEventListener('orientationchange', this.calculateScrollableHeight);
    },
    
    updated() {
        // Recalcular cuando el componente se actualiza
        this.$nextTick(() => {
            this.calculateScrollableHeight();
        });
    },
    
    beforeDestroy() {
        // Limpiar event listeners
        window.removeEventListener('resize', this.calculateScrollableHeight);
        window.removeEventListener('orientationchange', this.calculateScrollableHeight);
        
        // Limpiar observadores
        this.cleanupObservers();
    }
};
</script>

<style scoped>
.dashboard {
    background-color: #00000000;
    min-height: 100vh;
}

.secondary-chart {
    margin-top: 21px;
}

.main-title {
    position: relative;
    margin-bottom: 0;
    font-size: 2.2rem;
    font-weight: 800;
    color: #1B212E;
    z-index: 1;
}

.right-column {
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.scrollable-content {
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
    /* Scroll suave */
    scroll-behavior: smooth;
    /* Estilos de scrollbar personalizados */
    scrollbar-width: thin;
    scrollbar-color: #0fbef96a transparent;
}

.scrollable-content::-webkit-scrollbar {
    width: 2px;
}

.scrollable-content::-webkit-scrollbar-track {
    background: transparent;
}

.scrollable-content::-webkit-scrollbar-thumb {
    background-color: #0fbef96a;
    border-radius: 1px;
}

.scrollable-content::-webkit-scrollbar-thumb:hover {
    background-color: #0fbef96a;
}

.h-100 {
    height: 100%;
}

.equal-height {
    display: flex;
    flex-wrap: wrap;
}

.equal-height>[class*='col-'] {
    display: flex;
    flex-direction: column;
}

.tree-section {
    .row {
        min-height: 100%;
    }
}

.title-responsive {
    font-size: 2.2rem;
}

@media (max-width: 1850px) {
    .title-responsive {
        font-size: 2rem;
    }
}

@media (max-width: 1155px) {
    .title-responsive {
        font-size: 1.8rem;
    }
}

@media (max-width: 900px) {
    .title-responsive {
        font-size: 1.5rem;
    }
}

@media (max-width: 700px) {
    .title-responsive {
        font-size: 1.3rem;
    }
}

@media (max-width: 600px) {
    .title-responsive {
        font-size: 1.2rem;
    }
}

@media (max-width: 768px) {
    .kpi-row > [class*='col-'] {
        margin-bottom: 0 !important;
    }
}

/* Grid principal mejorado */
.dashboard-grid {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 0 24px;
    align-items: start; /* Cambiado de stretch a start */
    min-height: 80vh;
}

.left-column, .right-column {
    min-width: 0;
    display: flex;
    flex-direction: column;
}

.left-column {
    /* Altura natural del contenido */
    height: fit-content;
}

.right-column {
    /* Altura fija para mantener sincronización */
    height: 80vh;
}

/* Responsive: En mobile volver al comportamiento normal */
@media (max-width: 1480px) {
    .dashboard-grid {
        display: block;
        min-height: unset;
    }
    
    .left-column, .right-column {
        height: auto;
    }
    
    .scrollable-content {
        max-height: none !important;
        height: auto !important;
        overflow-y: visible;
    }
}

/* Mejorar la transición cuando cambia la altura */
.scrollable-content {
    transition: max-height 0.2s ease-out;
}
</style>